import _ from 'lodash';
import React from 'react';
import {NavLink} from 'react-router-dom';
import styled from 'styled-components';
import {colorTheme} from '../../../mixin/colorTheme';
import {btnColorCondition, btnType} from '../btn-conditions/btnTypeCondition';
import {basicBtnSetup} from '../btn-setup/btnStyling';

/**
 * @param {object} param0 Props
 * @description Button & anchor component setup for Tarasa.
 * See buttons.md for more information on when and how to use.
 *
 * @param {boolean} [param0.round]
 * If true, the button will have rounded corners.
 *
 * @param {boolean} [param0.ghost]
 * If true, the button will have a ghost style with a transparent background.
 *
 * @param {boolean} [param0.link]
 * If true, the button will have a link style with a transparent background and a transparent border.
 *
 * @param {string} [param0.color]
 * CSS variable names to use for:
 *   - 'background color if default'
 *   - 'color for link type (text only)'
 *   - 'text color and outline color for ghost type'
 *
 * The color of the button, which can be one of the following options:
 *   - 'primary'
 *   - 'success'
 *   - 'danger'
 *   - 'default'
 *
 * @param {string} [param0.size]
 * CSS variable names to use for a different button size:
 *
 * The size of the button, which can be one of the following options:
 *   - 'sm'
 *   - 'lg'
 *
 * @param {import('react').HTMLAttributeAnchorTarget} [param0.target]
 * The target attribute specifies where to open the linked document.
 */
export const NavLinkWrapper = (props) => {
    let newProps = _.omit(props, ['color', 'round', 'ghost', 'link', 'space']);
    return <NavLink {...newProps} />;
};

export const InternalNavLink = styled(NavLinkWrapper)`
    ${basicBtnSetup};
    ${({color, round, ghost, link}) => btnType(color, round, ghost, link)};
    ${colorTheme({
        // === black ===
        '--btn-default     ': {dark: 'var(--honey-00)  ', light: 'var(--gray-13)'},
        '--btn-default-dark': {dark: 'var(--honey-01)  ', light: 'var(--gray-14)'},
    })};
    ${({color, ghost, link}) => btnColorCondition(color, ghost, link)};
`;
